import { mainNum } from '../constants'

const validates = {
    mainSpareImage: {
        name: 'mainSpareImage',
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        validate: {
            name: '主图',
            validatorNum: mainNum,
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                minWidth: 600,
                minHeight: 600,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
            ratioValidator: {
                ratio: 1 / 1,
            },
        },
    },
    mainImageThreeFour: {
        name: 'mainImageThreeFour',
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        validate: {
            name: '3:4主图',
            validatorNum: mainNum,
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                minWidth: 375,
                minHeight: 500,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
            ratioValidator: {
                // eslint-disable-next-line no-magic-numbers
                ratio: 3 / 4,
            },
        },
    },
    whiteGroundImage: {
        name: 'whiteGroundImage',
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        validate: {
            name: '白底图',
            validatorNum: 1,
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                minWidth: 600,
                minHeight: 600,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
            ratioValidator: {
                ratio: 1 / 1,
            },
        },
    },
    longImageThreeFour: {
        name: 'longImageThreeFour',
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        validate: {
            name: '3:4导购图',
            validatorNum: 1,
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                minWidth: 375,
                minHeight: 500,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
            ratioValidator: {
                ratio: 0.75,
            },
        },
    },
    goodsSku: {
        name: 'goodsSku',
        validate: {
            name: '规格图',
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            ratioValidator: {
                ratio: 1 / 1,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
        },
    },
    description: {
        name: 'description',
        validate: {
            name: '商品详情',
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                maxWidth: 5000,
                maxHeight: 20000,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
        },
    },
    size: {
        name: 'size',
        validate: {
            name: '尺码图',
            validatorNum: 1,
            sizeValidator: {
                minSize: 0,
                maxSize: 5,
            },
            rectValidator: {
                maxWidth: 5000,
                maxHeight: 20000,
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'],
            },
        },
    },
}

// 给铺货模版的配置
export const goodsQuickSets = [
    validates.mainSpareImage,
    validates.mainImageThreeFour,
    validates.whiteGroundImage,
    validates.goodsSku,
    validates.description,
]

// 商品主图、3:4主图、 白底图, 规格图、白底图
export default validates
